import { PortableText, type PortableTextBlock } from 'next-sanity';

import { cn } from '#/lib/utils';

type Props = {
  value: PortableTextBlock[];
  className?: string;
  /** Class applied to text marked with the Highlight decorator. */
  highlightClass?: string;
};

/**
 * Renderer for the `simpleRichText` schema: paragraphs, bold, italic and
 * highlight. Colours are intentionally inherited from the parent so the same
 * content reads correctly on any themed surface (light or dark).
 */
export function SimpleRichText({
  value,
  className,
  highlightClass = 'text-cipher',
}: Props) {
  return (
    <div className={cn('flex flex-col gap-8', className)}>
      <PortableText
        value={value}
        components={{
          block: {
            normal: ({ children }) => (
              <p className="type-paragraph m:type-paragraph-lg">{children}</p>
            ),
          },
          marks: {
            strong: ({ children }) => (
              <strong className="font-medium">{children}</strong>
            ),
            em: ({ children }) => <em className="italic">{children}</em>,
            highlight: ({ children }) => (
              <span className={highlightClass}>{children}</span>
            ),
          },
        }}
      />
    </div>
  );
}
